import Joi from 'joi';

import { AppSubjectEnum } from '../../../../shared/modules/authz/enums/app-subject.enum';
import { createLocationContactSchema } from '../../../contacts/validators/schemas/create-location-contact.schema';
import { createPoliciesAssignSchema } from '../../../policies/validators/schemas/policies-assign.schema';
import { createTagsSchema } from '../../../tags/validators/schemas/create-tags.schema';
import { LocationTypeEnum } from '../../enums/location-type.enum';

/**
 * Schema for new location record validation.
 */
export const createLocationSchema = () =>
  Joi.object({
    // Code
    code: Joi.string().allow(null).messages({
      'string.base': 'validations|location-code|must-be-string',
    }),

    color: Joi.string().optional().allow(null, ''),

    notes: Joi.string().allow(null, '').messages({
      'string.base': 'validations|location-notes|must-be-string',
    }),

    // Area
    areaId: Joi.number().integer().allow(null).messages({
      'number.base': 'validations|location-area-id|must-be-number',
    }),

    // GPS coordinates
    gpsCoordinates: Joi.object({
      coordinates: Joi.array().items(Joi.number()).allow(null),
    })
      .allow(null)
      .messages({
        'object.base': 'validations|location-gps-coordinates|invalid-value',
      }),

    // Name
    name: Joi.alternatives().conditional(Joi.any().valid(null), {
      then: Joi.invalid(null).messages({
        'any.invalid': 'validations|location-name|cannot-be-null',
      }),
      otherwise: Joi.string().required().messages({
        'any.required': 'validations|location-name|required',
        'string.base': 'validations|location-name|must-be-string',
        'string.empty': 'validations|location-name|must-not-be-empty',
      }),
    }),

    // Type
    type: Joi.alternatives().conditional(Joi.any().valid(null), {
      then: Joi.invalid(null).messages({
        'any.invalid': 'validations|location-type|cannot-be-null',
      }),
      otherwise: Joi.string()
        .valid(...Object.values(LocationTypeEnum))
        .required()
        .messages({
          'any.required': 'validations|location-type|required',
          'any.only': 'validations|location-type|invalid-value',
        }),
    }),

    // Contact
    contact: createLocationContactSchema(),

    // Tags
    tags: createTagsSchema().messages({
      'array.base': 'validations|location-tags|invalid-value',
    }),

    // Policies
    policies: createPoliciesAssignSchema(AppSubjectEnum.LOCATION),

    // Pickup / dropoff / private flags
    isPickUp: Joi.boolean().empty(null).default(false),
    isDropOff: Joi.boolean().empty(null).default(false),
    isPrivate: Joi.boolean().empty(null).default(false),

    // Files
    files: Joi.any().optional(),
  });
